export default __webpack_public_path__ + "static/media/background1.cb7421dc.png";